import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InfoPage } from './info.page';

const routes: Routes = [
	{
		path: '',
		component: InfoPage,
		children: [
			{
				path: 'schedule',
				loadChildren: () =>
					import('./schedule/schedule.module').then(m => m.SchedulePageModule),
			},
			{
				path: 'jobfair-announce',
				loadChildren: () =>
					import('./jobfair-announce/jobfair-announce.module').then(
						m => m.JobfairAnnouncePageModule,
					),
			},
			{
				path: 'notification-data',
				loadChildren: () =>
					import('./notification-data/notification-data.module').then(
						m => m.NotificationDataPageModule,
					),
			},
			{
				path: 'jobfair-faq',
				loadChildren: () =>
					import('./jobfair-faq/jobfair-faq.module').then(
						m => m.JobfairFAQPageModule,
					),
			},
			{
				path: 'participants',
				loadChildren: () =>
					import('./participants/participants.module').then(
						m => m.ParticipantsPageModule,
					),
			},
			{
				path: 'participatingcompanies',
				loadChildren: () =>
					import('./participatingcompanies/participatingcompanies.module').then(
						m => m.ParticipatingcompaniesPageModule,
					),
			},
			{
				path: 'schedule-event',
				loadChildren: () => import('./schedule-event/schedule-event.module').then( m => m.ScheduleEventPageModule)
			  },
		]
	}
  
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class InfoPageRoutingModule {}
